import React from "react";
export default function Footer() {
  return (
    <footer>
      This project was coded by{" "}
      <a
        href="https://pt.linkedin.com/in/anacatarinagarcia"
        target="_blank"
        rel="noopener noreferrer"
      >
        Catarina Garcia
      </a>{" "}
      and is{" "}
      <a
        href="https://github.com/acatarinagarcia/weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        open-sourced on GitHub
      </a>
    </footer>
  );
}
